import React, { useEffect, useState, useRef } from 'react';
import './Header.css';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Divider,
  Drawer,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Menu,
  Toolbar,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  ArrowDropDownOutlined,
  ArrowDropUpOutlined,
  Menu as MenuIcon,
  ChevronRightOutlined,
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
  CloseRounded
} from '@mui/icons-material';
import { MenuList, MostRecentlyVisitedIndianPlace } from '../../constants/headerConstant';
import { convertToHyphenatedLowerCase } from '../../helper/global';
import { api } from '../../APIs/api';
import { API_URL, BASE_URL } from '../../APIs/endpoint';
import { toast } from 'react-toastify';
import KesariInbound from '../../assets/images/Kesari-Inbound-Logo.png';
import Years42Logo from '../../assets/images/42-years-logo.png';
// import VectorSignIcon from '../../assets/images/Vector_Sign.svg';
import SearchDestination from './SearchDestination';

const Header = ({
  mustSeeRef,
  exploreMapRef,
  whyIndiaRef,
  seasonalTripsRef,
  reviewRef,
  faqRef
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState('East India');
  const [activeMenu, setActiveMenu] = useState('');
  const [indiaOpen, setIndiaOpen] = useState(false);
  const [openRegions, setOpenRegions] = useState({});
  const [openStates, setOpenStates] = useState({});
  const [headerData, setHeaderData] = useState({});
  const [opacity, setOpacity] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  const menuContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuContainerRef.current && !menuContainerRef.current.contains(event.target)) {
        setActiveMenu('');
        setSubmenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (submenuOpen && activeMenu === 'India') {
      setOpacity(1);
    }
  }, [submenuOpen, activeMenu]);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    setScrollY(currentScrollY);
    if (currentScrollY === 0 && activeMenu !== 'India') {
      setActiveMenu('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeMenu]);

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const toggleIndiaMenu = () => {
    setIndiaOpen((prev) => !prev);
    if (indiaOpen) {
      setOpenRegions({});
      setOpenStates({});
    }
  };

  const toggleRegionMenu = (region) => {
    setOpenRegions((prev) => {
      const newOpenRegions = { ...prev, [region]: !prev[region] };
      if (!newOpenRegions[region]) {
        const newOpenStates = {};
        Object.keys(headerData[region]).forEach((state) => {
          newOpenStates[state] = false;
        });
        setOpenStates(newOpenStates);
      }
      return newOpenRegions;
    });
  };

  const toggleStateMenu = (state) => {
    const region = Object.keys(headerData).find((region) => headerData[region][state]);
    if (region) {
      const cities = headerData[region][state];
      if (cities.length > 0) {
        setOpenStates((prev) => ({
          ...prev,
          [state]: !prev[state]
        }));
      } else {
        toggleDrawer(false)();
        navigate(
          `/explore/india/${convertToHyphenatedLowerCase(region)}/${convertToHyphenatedLowerCase(
            state
          )}`
        );
      }
    }
  };

  const getHeaderMenuListApi = async () => {
    try {
      const headerMenuRes = await api.get(`${BASE_URL}${API_URL.HEADER_MENU}`);
      const { status, data } = headerMenuRes;
      if (status && data && data.Domestic) {
        const modifiedDomesticData = {};
        Object.keys(data.Domestic).forEach((zone) => {
          const zoneWithIndia = `${zone} India`;
          modifiedDomesticData[zoneWithIndia] = data.Domestic[zone];
        });
        const sortedDomesticData = Object.keys(modifiedDomesticData)
          .sort()
          .reduce((acc, key) => {
            acc[key] = modifiedDomesticData[key];
            return acc;
          }, {});
        setHeaderData(sortedDomesticData);
      }
    } catch (err) {
      toast.error(err.message, { autoClose: 3000 });
    }
  };

  const handleMenuClick = (event, menuItem, index) => {
    const selectedMenu = MenuList[index].menu;
    if (selectedMenu === 'Must-See') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        mustSeeRef?.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (selectedMenu === 'Explore Map') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        exploreMapRef?.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (selectedMenu === 'Why India') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        whyIndiaRef?.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (selectedMenu === 'Seasonal Trips') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        seasonalTripsRef?.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (selectedMenu === 'Reviews') {
      const reviewSection = reviewRef?.current || document.getElementById('reviewCard');
      reviewSection?.scrollIntoView({ behavior: 'smooth' });
    } else if (selectedMenu === 'FAQ') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        faqRef?.current?.scrollIntoView({ behavior: 'smooth' });
      }
    }

    if (menuItem === 'India') {
      setAnchorEl(anchorEl ? null : event.currentTarget);
      setSubmenuOpen(!submenuOpen);
      setActiveMenu(menuItem);
    } else {
      setActiveMenu(menuItem);
      setSubmenuOpen(false);
    }
  };

  const handleMobileMenu = (event, menuItem, index) => {
    const selectedMenu = MenuList[index].menu;
    if (selectedMenu === 'Must-See') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        toggleDrawerAndScroll(mustSeeRef);
      }
    } else if (selectedMenu === 'Explore Map') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        toggleDrawerAndScroll(exploreMapRef);
      }
    } else if (selectedMenu === 'Why India') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        toggleDrawerAndScroll(whyIndiaRef);
      }
    } else if (selectedMenu === 'Seasonal Trips') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        toggleDrawerAndScroll(seasonalTripsRef);
      }
    } else if (selectedMenu === 'Reviews') {
      setDrawerOpen(false);
      setTimeout(() => {
        const reviewSection = reviewRef?.current || document.getElementById('reviewCard');
        reviewSection?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else if (selectedMenu === 'FAQ') {
      if (pathname?.split('/')[1] !== '') {
        navigate('/');
      } else {
        toggleDrawerAndScroll(faqRef);
      }
    }

    if (menuItem === 'India') {
      setAnchorEl(anchorEl ? null : event.currentTarget);
      toggleIndiaMenu();
    }
  };

  const toggleDrawerAndScroll = (ref) => {
    setDrawerOpen(false);
    setTimeout(() => {
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  useEffect(() => {
    getHeaderMenuListApi();
    const selectedIndex = sessionStorage.getItem('menuIndex');
    const scrollTarget = MenuList[selectedIndex]?.menu;
    if (scrollTarget) {
      setTimeout(() => {
        if (scrollTarget === 'Must-See') {
          mustSeeRef?.current?.scrollIntoView({ behavior: 'smooth' });
        } else if (scrollTarget === 'Explore Map') {
          exploreMapRef?.current?.scrollIntoView({ behavior: 'smooth' });
          sessionStorage.setItem('menuIndex', null);
        } else if (scrollTarget === 'Why India') {
          whyIndiaRef?.current?.scrollIntoView({ behavior: 'smooth' });
          sessionStorage.setItem('menuIndex', null);
        } else if (scrollTarget === 'Seasonal Trips') {
          seasonalTripsRef?.current?.scrollIntoView({ behavior: 'smooth' });
          sessionStorage.setItem('menuIndex', null);
        } else if (scrollTarget === 'Reviews') {
          const reviewSection = reviewRef?.current || document.getElementById('reviewCard');
          reviewSection?.scrollIntoView({ behavior: 'smooth' });
          sessionStorage.setItem('menuIndex', null);
        } else if (scrollTarget === 'FAQ') {
          faqRef?.current?.scrollIntoView({ behavior: 'smooth' });
          sessionStorage.setItem('menuIndex', null);
        }
      }, 100);
      setTimeout(() => {
        sessionStorage.setItem('menuIndex', null);
      }, 1000);
    }
  }, [pathname, mustSeeRef, exploreMapRef, whyIndiaRef, seasonalTripsRef, reviewRef, faqRef]);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuOpen(false);
    setActiveMenu('');
    setOpacity(0);
    setSelectedRegion('East India');
  };

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
  };

  const chunkArray = (array, parts) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / parts);
    for (let i = 0; i < parts; i++) {
      result.push(array.slice(i * chunkSize, i * chunkSize + chunkSize));
    }
    return result;
  };

  return (
    <Box
      className="header-container header-container-kesari"
      sx={{ zIndex: isMobile ? 1000 : 5000 }}>
      <AppBar
        position="static"
        style={{
          backgroundColor: '#FFFFFF',
          boxShadow: 'none',
          position: 'relative'
        }}>
        <Toolbar
          sx={{
            justifyContent: { lg: 'center' },
            marginLeft: { md: '0px', lg: '95px' }
          }}>
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              style={{ color: '#000000B2' }}>
              <MenuIcon />
            </IconButton>
          )}

          <Box
            display="flex"
            alignItems="center"
            flexGrow={0.3}
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate('/')}>
            <Box
              component="img"
              src={KesariInbound}
              alt="Kesari Inbound Logo"
              sx={{
                height: { xs: 80, sm: 80 },
                width: { xs: 190, sm: 230 },
                objectFit: 'contain'
              }}
            />
          </Box>
          {!isMobile && (
            <>
              <Box
                display="flex"
                flexGrow={1}
                justifyContent="center"
                alignItems="center"
                ml={1}
                sx={{ gap: { md: 0, lg: 1 }, height: '80px', whiteSpace: 'nowrap' }}>
                {MenuList.map((menuItem, i) => (
                  <Button
                    className="desktop-menu-title"
                    key={menuItem.menu}
                    color="inherit"
                    onClick={(event) => handleMenuClick(event, menuItem.menu, i)}
                    sx={{
                      color:
                        scrollY === 0 && activeMenu === ''
                          ? '#000000'
                          : activeMenu === menuItem.menu
                          ? '#FFFFFF'
                          : '#000000',
                      backgroundColor:
                        scrollY === 0 && activeMenu === ''
                          ? 'transparent'
                          : activeMenu === menuItem.menu
                          ? '#E41E25'
                          : 'transparent',
                      borderRadius: activeMenu === menuItem.menu ? 0 : '4px',
                      height: '80px',
                      width: 'maxContent',
                      transition: 'background-color 0.3s'
                    }}>
                    {menuItem.menu}
                    {menuItem.menu === 'India' &&
                      (submenuOpen ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />)}
                  </Button>
                ))}
              </Box>

              <Box
                display="flex"
                flexGrow={1}
                justifyContent="center"
                alignItems="center"
                sx={{ gap: 2, height: '80px', whiteSpace: 'nowrap' }}>
                <Box
                  className="Hiren-123"
                  display={isTablet ? 'none' : 'inline-block'}
                  sx={{
                    marginLeft: { md: '0px', lg: '16px' },
                    marginRight: { md: '0px', lg: '16px' }
                  }}>
                  <SearchDestination />
                </Box>
                <Typography
                  component="span"
                  sx={{
                    fontFamily: 'gothamBold',
                    color: '#E41E25',
                    backgroundColor: 'transparent',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}>
                  <span style={{ fontSize: 'inherit' }}>INBOUND</span>
                  <span style={{ fontSize: isTablet ? '10px' : '12px', lineHeight: '1.2' }}>
                    FOR FOREIGN NATIONALS
                  </span>
                </Typography>
                <img
                  src={Years42Logo}
                  alt="42 years Logo"
                  style={{ height: '75px', marginRight: '5px', width: '75px' }}
                />
              </Box>

              {/* <Button className="signin-btn">
                <img src={VectorSignIcon} alt="Vector_signin" style={{ marginRight: '8px' }} />
                Sign In
              </Button> */}
            </>
          )}
          {isMobile && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                height: '80px',
                whiteSpace: 'nowrap',
                marginLeft: { xs: 0, sm: '20px' }
              }}>
              <SearchDestination />

              <Typography
                component="span"
                sx={{
                  fontFamily: 'gothamBold',
                  color: '#E41E25',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginLeft: { xs: '24px', sm: '42px' }
                }}>
                <span style={{ fontSize: 'inherit' }}>INBOUND</span>
                <span style={{ fontSize: '8px', lineHeight: '1.2' }}>FOR FOREIGN NATIONALS</span>
              </Typography>
              {/* <img
                src={Years40Logo}
                alt="40 years Logo"
                style={{ height: '70px', marginRight: '5px', width: '70px' }}
              /> */}
            </Box>
          )}
          {/* {isMobile && <Button className="login-btn">Login</Button>} */}
        </Toolbar>
      </AppBar>

      <Menu
        ref={menuContainerRef}
        id="india-menu"
        anchorEl={anchorEl}
        keepMounted
        open={submenuOpen && activeMenu === 'India'}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        sx={{
          '& .MuiPaper-root': {
            width: 920,
            padding: '10px',
            paddingRight: '0px',
            paddingBottom: '0px',
            height: '290px',
            borderRadius: 0,
            backgroundColor: '#FFFFFF',
            top: opacity === 1 ? '80px !important' : '16px',
            left: opacity === 1 ? '300px !important' : '251px',
            position: 'relative',
            opacity: opacity
          }
        }}>
        <Box display="flex" flexWrap="wrap" alignItems="center" mb={2}>
          <Typography
            component="span"
            sx={{ fontFamily: 'gothamBold', fontSize: '14px', whiteSpace: 'nowrap' }}>
            Most Visited Places:
          </Typography>
          <Box
            display="flex"
            flexWrap="nowrap"
            alignItems="center"
            sx={{ overflowX: 'auto', whiteSpace: 'nowrap', marginLeft: '10px' }}>
            {MostRecentlyVisitedIndianPlace.map((place, index) => (
              <Box key={place.title} display="inline-flex" alignItems="center">
                {index > 0 && <span style={{ margin: '0 8px', display: 'inline-block' }}>|</span>}
                <ListItem
                  button
                  onClick={() => navigate(place.url)}
                  sx={{ padding: 0, minWidth: 'auto' }}>
                  <ListItemText
                    primary={
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'gothamBook',
                          fontSize: '14px',
                          '&:hover': {
                            color: '#1976d2'
                          }
                        }}>
                        {place.title}
                      </Typography>
                    }
                  />
                </ListItem>
              </Box>
            ))}
          </Box>
        </Box>

        <Grid container spacing={2} mt={2} sx={{ backgroundColor: '#FFFFFF' }}>
          <Grid item xs={3} sx={{ paddingTop: '0 !important', paddingLeft: '0 !important' }}>
            <List sx={{ padding: 0, margin: 0 }}>
              {Object.keys(headerData).map((region) => (
                <ListItem
                  key={region}
                  button
                  onClick={() => handleRegionSelect(region)}
                  selected={selectedRegion === region}
                  sx={{
                    backgroundColor: selectedRegion === region ? '#F4F4F7' : 'transparent',
                    height: '55px'
                  }}>
                  <ListItemText
                    primary={
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: selectedRegion === region ? 'gothamBold' : 'gothamMedium',
                          color: selectedRegion === region ? '#000000' : '#000000B2',
                          fontSize: '16px'
                        }}>
                        {region}
                      </Typography>
                    }
                  />
                  <ChevronRightOutlined style={{ marginRight: '8px' }} />
                </ListItem>
              ))}
            </List>
          </Grid>

          <Grid item xs={9} sx={{ backgroundColor: '#F4F4F7', height: '228px' }}>
            <Grid container spacing={2} alignItems="flex-start">
              {headerData?.[selectedRegion] &&
                chunkArray(Object.keys(headerData[selectedRegion]), 3).map((part, partIndex) => (
                  <Grid container item xs={12} spacing={2} key={partIndex}>
                    {part.map((state) => {
                      const cities = headerData[selectedRegion][state];
                      return (
                        <Grid item xs={4} key={state}>
                          <Typography component="span" className="state-title1">
                            <ListItem
                              button
                              onClick={() => {
                                navigate(
                                  `/explore/india/${convertToHyphenatedLowerCase(
                                    selectedRegion
                                  )}/${convertToHyphenatedLowerCase(state)}`
                                );
                                handleMenuClose();
                              }}
                              sx={{
                                '&:hover': {
                                  backgroundColor: '#e0e0e0'
                                }
                              }}>
                              <ListItemText
                                primary={
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontFamily: 'gothamBold',
                                      fontSize: '14px',
                                      lineHeight: '20px',
                                      textAlign: 'left',
                                      cursor: 'pointer',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      '&:hover': {
                                        color: '#1976d2'
                                      }
                                    }}>
                                    {state}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          </Typography>
                          <Divider />
                          <List
                            sx={{
                              paddingBottom: cities?.length === 0 ? '0 !important' : 'initial'
                            }}>
                            {cities?.length > 0 &&
                              cities.map((city, cityIndex) => (
                                <ListItem
                                  key={cityIndex}
                                  button
                                  onClick={() => {
                                    navigate(
                                      `/explore/india/${convertToHyphenatedLowerCase(
                                        state
                                      )}/${convertToHyphenatedLowerCase(city)}`
                                    );
                                    handleMenuClose();
                                  }}>
                                  <ListItemText
                                    primary={<Typography component="span">{city}</Typography>}
                                  />
                                </ListItem>
                              ))}
                          </List>
                        </Grid>
                      );
                    })}
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>
      </Menu>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: '10px'
          }}>
          <IconButton
            onClick={toggleDrawer(false)}
            sx={{
              color: 'rgba(0, 0, 0, 0.698)',
              marginLeft: '5px'
            }}
            aria-label="close">
            <CloseRounded />
          </IconButton>
        </Box>
        <Box p={2} width="250px">
          <List>
            {MenuList.map((menuItem, i) => (
              <React.Fragment key={menuItem.menu}>
                <ListItem button onClick={(event) => handleMobileMenu(event, menuItem.menu, i)}>
                  <ListItemText
                    primary={<Typography component="span">{menuItem.menu}</Typography>}
                  />
                  {menuItem.menu === 'India' &&
                    (indiaOpen ? <ArrowDropUpOutlined /> : <ArrowDropDownOutlined />)}
                </ListItem>

                {menuItem.menu === 'India' && indiaOpen && (
                  <List component="div" disablePadding>
                    {Object.keys(headerData).map((region) => (
                      <React.Fragment key={region}>
                        <ListItem button onClick={() => toggleRegionMenu(region)} sx={{ pl: 4 }}>
                          <ListItemText
                            primary={<Typography component="span">{region}</Typography>}
                          />
                          {openRegions[region] ? (
                            <ArrowDropUpOutlined />
                          ) : (
                            <ArrowDropDownOutlined />
                          )}
                        </ListItem>

                        {openRegions[region] && (
                          <List component="div" disablePadding>
                            {Object.keys(headerData[region]).map((state) => {
                              const cities = headerData[region][state];
                              return (
                                <React.Fragment key={state}>
                                  <ListItem
                                    button
                                    onClick={() => toggleStateMenu(state)}
                                    sx={{ pl: 6 }}>
                                    <ListItemText
                                      primary={<Typography component="span">{state}</Typography>}
                                      sx={{
                                        fontFamily: 'gothamBold',
                                        fontSize: '14px',
                                        lineHeight: '20px',
                                        textAlign: 'left',
                                        cursor: 'pointer'
                                      }}
                                    />
                                    {cities.length > 0 &&
                                      (openStates[state] ? (
                                        <ArrowDropUpOutlined />
                                      ) : (
                                        <ArrowDropDownOutlined />
                                      ))}
                                  </ListItem>

                                  {cities.length > 0 && openStates[state] && (
                                    <Box display="flex" flexWrap="wrap" sx={{ pl: 8 }}>
                                      {cities.map((city, cityIndex) => (
                                        <ListItem
                                          key={cityIndex}
                                          button
                                          sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            width: 'auto',
                                            px: 1,
                                            py: 0.5
                                          }}
                                          onClick={() =>
                                            navigate(
                                              `/explore/india/${convertToHyphenatedLowerCase(
                                                state
                                              )}/${convertToHyphenatedLowerCase(city)}`
                                            )
                                          }>
                                          <ListItemText
                                            primary={
                                              <Typography component="span">{city}</Typography>
                                            }
                                          />
                                        </ListItem>
                                      ))}
                                    </Box>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </List>
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                )}
              </React.Fragment>
            ))}
          </List>
          <Divider sx={{ my: 2, borderColor: 'grey.400', borderWidth: '1px' }} />
          <Box
            display="flex"
            alignItems="center"
            mb={2}
            justifyContent="center"
            onClick={() => {
              if (pathname === '/') {
                toggleDrawer(false)();
              } else {
                navigate('/');
                toggleDrawer(false)();
              }
            }}>
            <Box
              component="img"
              src={KesariInbound}
              alt="Kesari Inbound Logo"
              sx={{
                objectFit: 'contain'
              }}
            />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Header;
